import { z } from "zod";

const gameCodeSchema = z.union([z.string(), z.number()]);

export const reqNonpaidReportGameSchema = z.object({
  serviceCode: gameCodeSchema.optional(),
  stateCode: z.string().optional(),
});

export const getNonpaidReportGameSchema = z.object({
  gameCode: gameCodeSchema,
  name: z.string(),
});

export const getNonpaidReportGamesSchema = z.array(getNonpaidReportGameSchema);

export type ReqNonpaidReportGameType = z.infer<typeof reqNonpaidReportGameSchema>;
export type GetNonpaidReportGamesType = z.infer<typeof getNonpaidReportGamesSchema>;
export type GameCodeType = z.infer<typeof gameCodeSchema>;
